import type { ReactNode } from 'react';
import type { EventTypePublic } from '../api/types';
import { useZeitwahl } from '../provider';
import { formatList } from '../time/format';
import { locationText } from './booking-details';

export interface EventTypeDetailsProps {
  eventType: EventTypePublic;
  locale?: string;
  children?: ReactNode;
}

/** Brand, title, duration, location, hosts and description — the left column of the flow. */
export function EventTypeDetails({
  eventType,
  locale: localeProp,
  children,
}: EventTypeDetailsProps): ReactNode {
  const { t, labels, locale: contextLocale } = useZeitwahl();
  const locale = localeProp ?? contextLocale;
  const location = locationText(eventType.location, labels);
  const hosts = eventType.hosts.map((h) => h.name).filter(Boolean);

  return (
    <div className="zw-event">
      {eventType.brand.logoUrl ? (
        <img className="zw-event-logo" src={eventType.brand.logoUrl} alt={eventType.brand.name} />
      ) : (
        <p className="zw-event-brand">{eventType.brand.name || eventType.org.name}</p>
      )}
      <h2 className="zw-title">{eventType.title}</h2>
      <ul className="zw-meta">
        <li>{t('eventDuration', { minutes: eventType.durationMinutes })}</li>
        {location && <li>{location}</li>}
        {hosts.length > 0 && <li>{t('eventWith', { names: formatList(hosts, locale) })}</li>}
      </ul>
      {eventType.description && <p className="zw-event-desc">{eventType.description}</p>}
      {children}
    </div>
  );
}
